<div class="bc-container bc-mb-5">
    <div class="bc-row bc-mb-5">
        <div class="bc-col-12">
            <app-title-and-breadcrumb [titulo]="titulo"></app-title-and-breadcrumb>
        </div>
    </div>
    <div class="bc-row">
        <div class="bc-col-6">
            <p class="sub-title-3">Datos de la factura</p>
        </div>
        <div class="bc-col-4 bc-text-end">
            <p class="sub-title-3">Estado de la factura</p>
        </div>
        <div class="bc-col-2 bc-text-end">
            <app-btn-cambio-estado [dataFactura]="dataFactura" [loading]="bcCircleLoading"></app-btn-cambio-estado>
        </div>
    </div>

    <div class="bc-mt-5 contenedor-informacion">
        <div class="bc-row">
            <div class="bc-col-4">
                <p class="titulo-data">Codigo de documento DIAN</p>
                <p class="valor-data">{{ dataFactura.tipo_documento?.codigo }}</p>
            </div>
            <div class="bc-col-4">
                <p class="titulo-data">Tipo de documento DIAN</p>
                <p class="valor-data">{{ dataFactura.tipo_documento?.significado }}</p>
            </div>
        </div>
        <div class="bc-row bc-mt-2">
            <div class="bc-col-4">
                <p class="titulo-data">Aliado</p>
                <p class="valor-data">{{ dataFactura.remitente }}</p>
            </div>
            <div class="bc-col-4">
                <p class="titulo-data">Nit del aliado</p>
                <p class="valor-data">{{ dataFactura.nit }}</p>
            </div>
            <div class="bc-col-4">
                <p class="titulo-data">Número de factura</p>
                <p class="valor-data red">{{ dataFactura.numero_factura }}</p>
            </div>
        </div>
        <div class="bc-row bc-mt-2">
            <div class="bc-col-4">
                <p class="titulo-data">Facturado a</p>
                <p class="valor-data">{{dataFactura.razons_adquiriente}}</p>
            </div>
            <div class="bc-col-4">
                <p class="titulo-data">Nit cliente</p>
                <p class="valor-data">{{dataFactura.nit_adquiriente}}</p>
            </div>
            <div class="bc-col-4">
                <p class="titulo-data">Departamento de emision</p>
                <p class="valor-data">{{ dataFactura.depEmision }}</p>
            </div>
        </div>
        <div class="bc-row bc-mt-2">
            <div class="bc-col-4">
                <p class="titulo-data">Ciudad de emision</p>
                <p class="valor-data">{{ dataFactura.ciudad }}</p>
            </div>
            <div class="bc-col-4">
                <p class="titulo-data">Ciudad Adquiriente</p>
                <p class="valor-data">{{dataFactura.ciuAdquiriente}}</p>
            </div>
        </div>
    </div>



    <div class="bc-mt-3 contenedor-informacion">
        <div class="bc-row">
            <div *ngFor="let tax of taxesBlock" class="bc-col-4">
                <p class="titulo-data">{{tax.desc}}</p>
                <p class="valor-data">COP {{identificarValortax(tax.code,dataFactura.tax) | currency}}</p>
            </div>
        </div>
        <div class="bc-row bc-mt-2">
            <div class="bc-col-4">
                <p class="titulo-data">Valor anticipo</p>
                <p class="valor-data">COP {{dataFactura.total_acticipos | currency}}</p>
            </div>
            <div class="bc-col-4">
                <p class="titulo-data">Total IVA</p>
                <p class="valor-data">COP {{obtenerIva(dataFactura) | currency}}</p>
            </div>
            <div class="bc-col-4">
                <p class="titulo-data">Subtotal</p>
                <p class="valor-data red">COP {{dataFactura.total_antes_impuestos | currency}}</p>
            </div>
        </div>
    </div>

    <div class="bc-row bc-mt-5 bc-p-4 bc-pe-5" style="background: #413E4D;border-radius: 8px;">
        <div class="bc-col-12">
            <div class="bc-row">
                <div class="bc-col-12 bc-text-end">
                    <p class="white">Valor a facturar</p>
                    <p class="white-font-weight">COP {{dataFactura.total_incl_impuestos | currency}}</p>
                </div>
            </div>
        </div>
    </div>


    <bc-tabs-group [tabType]="'regular'" [iconPosition]="'right'">
        <bc-tab label="Información adicional" [icon]="'book'">
            <div class="bc-row">
                <div class="bc-col-12">
                    <bc-table-container *ngIf="dataFactura.items" class="bc-col-12 " [dataTable]="dataFactura.items">
                        <bc-table-header title="Conceptos">
                        </bc-table-header>
                        <bc-table-content>
                            <table caption="tabla" bc-table [sort]="true" [pairPaginators]="true" [dropdownHtml]="true">
                                <thead>
                                    <tr>
                                        <th scope="row" bc-cell scope="col">Concepto</th>
                                        <th scope="row" bc-cell scope="col">Cantidad</th>
                                        <th scope="row" bc-cell scope="col">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of dataFactura.items">
                                        <td bc-cell>{{ row.desc }}</td>
                                        <td bc-cell>{{ row.cant }}</td>
                                        <td bc-cell>{{ row.precio | currency }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </bc-table-content>
                    </bc-table-container>
                </div>
            </div>


            <div class="bc-row bc-mt-5">
                <div class="bc-col-4">
                    <p>Fecha de inicio del periodo de facturación</p>
                    <p class="concepto">{{dataFactura.fecha_inicio}}</p>
                </div>
                <div class="bc-col-4">
                    <p>Fecha de fin del periodo de facturación</p>
                    <p class="concepto">{{dataFactura.fecha_fin}}</p>
                </div>
                <div class="bc-col-4">
                    <p>Fecha de emisión de la orden</p>
                    <p class="concepto">{{dataFactura.fecha_emision}}</p>
                </div>
            </div>
        </bc-tab>
        <bc-tab label="Archivos adjuntos" [icon]="'attachment'">

            <listar-archivos-adjuntos [dataFactura]="dataFactura"
                [loading]="bcCircleLoading"></listar-archivos-adjuntos>

        </bc-tab>
        <bc-tab label="Adjuntar Archivo" [icon]="'calendar-historical'">
            <div class="bc-mt-4 contenedor-informacion">

                <subir-archivo-adjunto [facturaDetalleComponent]="this" [dataFactura]="dataFactura" [loading]="bcCircleLoading"></subir-archivo-adjunto>

            </div>
        </bc-tab>
    </bc-tabs-group>

    <div class="bc-row bc-mt-5">
        <div class="bc-col-5"></div>
        <div class="bc-col-2">
            <button bc-button class="btn-volver" typeButton="primary" sizeButton="small" routerLink="/home">Volver al
                inicio</button>
        </div>
        <div class="bc-col-5"></div>
    </div>
    <div class="bc-row">
        <div class="bc-col-12">
            <app-modal [bandera]="isModal" [title]="titleModal" [typeIcon]="typeIconModal" customWidth="medium"
                [body]="bodyModal" [subBody]="subBodyModal"></app-modal>

        </div>
    </div>
    <div class="bc-row">
        <div class="bc-col-12">
            <bc-circle-loading [text]="circleLoadingText" [accessibilityLabel]="circleLoadingAriaLabel"
                [speedLoader]="loaderSpeed" #loadingCircleFacturaDetalle>
            </bc-circle-loading>
        </div>
    </div>
</div>